import React, { useState, useEffect } from 'react';
import { Alert, Slide, Box } from '@mui/material';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import WifiIcon from '@mui/icons-material/Wifi';

export default function OfflineBar() {
  const [isOnline,     setIsOnline]     = useState(navigator.onLine);
  const [showOnline,   setShowOnline]   = useState(false);
  const [wasOffline,   setWasOffline]   = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      if (wasOffline) {
        setShowOnline(true);
        setTimeout(() => setShowOnline(false), 3000);
      }
    };
    const handleOffline = () => {
      setIsOnline(false);
      setWasOffline(true);
    };

    window.addEventListener('online',  handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online',  handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [wasOffline]);

  if (isOnline && !showOnline) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 52, // below AppBar
        left: 0,
        right: 0,
        zIndex: 1400,
      }}
    >
      <Slide direction="down" in={!isOnline || showOnline} mountOnEnter unmountOnExit>
        <Alert
          severity={isOnline ? 'success' : 'warning'}
          icon={isOnline ? <WifiIcon /> : <WifiOffIcon />}
          sx={{
            borderRadius: 0,
            py: 0.5,
            fontSize: '0.8rem',
            fontWeight: 600,
            justifyContent: 'center',
            '& .MuiAlert-message': { textAlign: 'center' },
          }}
        >
          {isOnline
            ? 'Lidhja u rivendos — aplikacioni është online.'
            : 'Nuk ka lidhje interneti — disa funksione mund të mos punojnë.'}
        </Alert>
      </Slide>
    </Box>
  );
}
